import { PREFIX } from '../../constants';

const generateBoxShadowAttributes = ({ controlName, defaults = {} }) => {
    const {
        [`${PREFIX}${controlName}BoxShadowPosition`]: boxShadowPosition = 'outset',
        [`${PREFIX}${controlName}BoxShadowColor`]: boxShadowColor,
        [`${PREFIX}${controlName}BoxShadowHorizontal`]: boxShadowHorizontal,
        [`${PREFIX}${controlName}BoxShadowVertical`]: boxShadowVertical,
        [`${PREFIX}${controlName}BoxShadowBlur`]: boxShadowBlur,
        [`${PREFIX}${controlName}BoxShadowSpread`]: boxShadowSpread
    } = defaults;

    return {
        [`${PREFIX}${controlName}BoxShadowPosition`]: {
            type: 'string',
            default: boxShadowPosition
        },
        [`${PREFIX}${controlName}BoxShadowColor`]: {
            type: 'string',
            default: boxShadowColor
        },
        [`${PREFIX}${controlName}BoxShadowHorizontal`]: {
            type: 'number',
            default: boxShadowHorizontal
        },
        [`${PREFIX}${controlName}BoxShadowVertical`]: {
            type: 'number',
            default: boxShadowVertical
        },
        [`${PREFIX}${controlName}BoxShadowBlur`]: {
            type: 'number',
            default: boxShadowBlur
        },
        [`${PREFIX}${controlName}BoxShadowSpread`]: {
            type: 'number',
            default: boxShadowSpread
        }
    };
};
export default generateBoxShadowAttributes;
